export default __webpack_public_path__ + "7f3ff6d2e3a577df5ce62db18a7b0544.webp";